import {
    ROUTES_REPORTS,
    ROUTES_REPORTS_OVERVIEW,
    ROUTES_REPORTS_ERGO,
    ROUTES_REPORTS_GMT,
    ROUTES_REPORTS_MORNING_MONITORING,
    ROUTES_REPORTS_MM_DAILY,
    ROUTES_REPORTS_MM_INJURY_ILLNESS,
    ROUTES_REPORTS_MM_TRAINING_QUALITY,
    ROUTES_REPORTS_ROWING,
    ROUTES_REPORTS_RPE,
    ROUTES_REPORTS_ATTENDANCE,
    ROUTES_REPORTS_TRAINING_SUMMARY,
    ROUTES_REPORTS_KAIZEN_TEAM,
    ROUTES_REPORTS_TEAM_ERGO_SUMMARY,
    ROUTES_REPORTS_STEP_TEST_GROUP,
    ROUTES_REPORTS_STEP_TEST_INDIVIDUAL,
    ROUTES_REPORTS_VO2_TEST_GROUP,
    ROUTES_REPORTS_VO2_TEST_INDIVIDUAL,
    ROUTES_REPORTS_2K_TEST_GROUP,
    ROUTES_REPORTS_2K_TEST_INDIVIDUAL,
    ROUTES_REPORTS_6K_TEST_GROUP,
    ROUTES_REPORTS_6K_TEST_INDIVIDUAL
} from '@/constants/routes';

const ReportsPage = () => import(/*webpackChunkName: 'reports'*/ '@/views/reports/ReportsMain.vue');
const ReportsMorningMonitoring = () =>
    import(/*webpackChunkName: 'reports'*/ '@/views/reports/ReportsMorningMonitoring.vue');
const ReportsOverview = () => import(/*webpackChunkName: 'reports'*/ '@/components/reports/overview/Overview.vue');
const ReportsErgo = () => import(/*webpackChunkName: 'reports-additional'*/ '@/components/reports/ergo/Ergo.vue');
const ReportsWater = () => import(/*webpackChunkName: 'reports-additional'*/ '@/components/reports/rowing/Rowing.vue');
const ReportsGMT = () => import(/*webpackChunkName: 'reports'*/ '@/components/reports/GMT/Gmt.vue');
const ReportsRpe = () => import(/*webpackChunkName: 'reports'*/ '@/components/reports/RPE/Rpe.vue');
const ReportsMorningMonitoringDaily = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/morning-monitoring/MorningMonitoringDaily.vue');
const ReportsMorningMonitoringInjuryIllness = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/morning-monitoring/MorningMonitoringInjuryIllness.vue');
const ReportsMorningMonitoringTrainingQuality = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/morning-monitoring/MorningMonitoringTrainingQuality.vue');
const ReportsAttendance = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/attendance/Attendance.vue');
const ReportsTrainingSummary = () =>
    import(/*webpackChunkName: 'reports'*/ '@/components/reports/training-summary/TrainingSummary.vue');
const ReportsKaizenTeam = () =>
    import(/*webpackChunkName: 'reports-additional'*/ '@/components/reports/kaizen-team/KaizenTeam.vue');
const ReportsTeamErgoSummary = () =>
    import(/*webpackChunkName: 'reports-additional'*/ '@/components/reports/team-ergo-summary/TeamErgoSummary.vue');
const ReportsStepTestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/step-tests/group/StepTests.vue');
const ReportsStepTestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/step-tests/individual/StepTests.vue');
const ReportsVo2TestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/vo2-tests/group/Vo2Tests.vue');
const ReportsVo2TestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/vo2-tests/individual/Vo2Tests.vue');
const Reports2kTestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/2k-tests/group/2kTests.vue');
const Reports2kTestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/2k-tests/individual/2kTests.vue');
const Reports6kTestGroup = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/6k-tests/group/6kTests.vue');
const Reports6kTestIndividual = () =>
    import(/*webpackChunkName: 'reports-drv'*/ '@/components/reports/6k-tests/individual/6kTests.vue');

export default {
    name: ROUTES_REPORTS,
    component: ReportsPage,
    path: '/reports',
    redirect: { name: ROUTES_REPORTS_OVERVIEW },
    children: [
        {
            name: ROUTES_REPORTS_OVERVIEW,
            path: '/reports',
            component: ReportsOverview
        },
        {
            name: ROUTES_REPORTS_ERGO,
            path: 'ergo',
            component: ReportsErgo
        },
        {
            name: ROUTES_REPORTS_ROWING,
            path: 'water',
            component: ReportsWater
        },
        {
            name: ROUTES_REPORTS_GMT,
            path: 'gmt',
            component: ReportsGMT
        },
        {
            name: ROUTES_REPORTS_MORNING_MONITORING,
            path: 'morning-monitoring',
            redirect: {
                name: ROUTES_REPORTS_MM_DAILY
            },
            component: ReportsMorningMonitoring,
            children: [
                {
                    name: ROUTES_REPORTS_MM_DAILY,
                    path: 'daily',
                    component: ReportsMorningMonitoringDaily
                },
                {
                    name: ROUTES_REPORTS_MM_INJURY_ILLNESS,
                    path: 'injury-illness',
                    component: ReportsMorningMonitoringInjuryIllness
                },
                {
                    name: ROUTES_REPORTS_MM_TRAINING_QUALITY,
                    path: 'training-quality',
                    component: ReportsMorningMonitoringTrainingQuality
                }
            ]
        },
        {
            name: ROUTES_REPORTS_RPE,
            path: 'rpe',
            component: ReportsRpe
        },
        {
            name: ROUTES_REPORTS_ATTENDANCE,
            path: 'attendance',
            component: ReportsAttendance
        },
        {
            name: ROUTES_REPORTS_TRAINING_SUMMARY,
            path: 'training-summary',
            component: ReportsTrainingSummary
        },
        {
            name: ROUTES_REPORTS_KAIZEN_TEAM,
            path: 'kaizen-team',
            component: ReportsKaizenTeam
        },
        {
            name: ROUTES_REPORTS_TEAM_ERGO_SUMMARY,
            path: 'team-ergo-summary',
            component: ReportsTeamErgoSummary
        },
        {
            name: ROUTES_REPORTS_STEP_TEST_GROUP,
            path: 'step-tests',
            component: ReportsStepTestGroup
        },
        {
            name: ROUTES_REPORTS_STEP_TEST_INDIVIDUAL,
            path: 'step-tests/:id',
            component: ReportsStepTestIndividual
        },
        {
            name: ROUTES_REPORTS_VO2_TEST_GROUP,
            path: 'vo2-tests',
            component: ReportsVo2TestGroup
        },
        {
            name: ROUTES_REPORTS_VO2_TEST_INDIVIDUAL,
            path: 'vo2-tests/:id',
            component: ReportsVo2TestIndividual
        },
        {
            name: ROUTES_REPORTS_2K_TEST_GROUP,
            path: '2k-tests',
            component: Reports2kTestGroup
        },
        {
            name: ROUTES_REPORTS_2K_TEST_INDIVIDUAL,
            path: '2k-tests/:id',
            component: Reports2kTestIndividual
        },
        {
            name: ROUTES_REPORTS_6K_TEST_GROUP,
            path: '6k-tests',
            component: Reports6kTestGroup
        },
        {
            name: ROUTES_REPORTS_6K_TEST_INDIVIDUAL,
            path: '6k-tests/:id',
            component: Reports6kTestIndividual
        }
    ]
};
